/**
 * Test-only crash trigger. When the URL contains `?__crash=1`, this
 * component throws during render so the GlobalErrorBoundary fallback can
 * be exercised by Playwright. No-op for every other visitor.
 */
export function CrashTrigger() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  if (params.get("__crash") === "1") {
    throw new Error("Intentional crash for boundary test");
  }
  return null;
}
